/**
 * Edição de participação em eleição.
 *
 * Salvar/Remover no topo, na linha do breadcrumb — padrão do painel.
 * A versão anterior misturava o wrapper <Edit> com um controller
 * próprio (duas buscas do mesmo registro) e deixava o Salvar no rodapé.
 */
import {
  AutocompleteInput,
  BooleanInput,
  EditContextProvider,
  NumberInput,
  ReferenceInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  useEditController,
} from "react-admin";
import { AppDeleteButton } from "../../components/AppDeleteButton";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { determineUserReadableRole } from "../users/UserUtils";

export const UserElectionEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    mutationMode: "pessimistic",
    resource: "user-elections/crud",
    id,
  });
  const isAdmin =
    determineUserReadableRole(localStorage.getItem("roles")) === "admin";

  const TopActions = () => (
    <>
      {isAdmin && <AppDeleteButton label="Remover" />}
      <SaveButton type="button" label="Salvar" />
    </>
  );

  return (
    <EditContextProvider value={controller}>
      {/* toolbar={false}: Salvar/Remover saem do rodapé e vão para o topo */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Eleições"
          firstPath="/#/user-elections/crud"
          secondTitle="Editando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="show"
          actions={<TopActions />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Dados da Eleição" />
          <CardContent>
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12}>
                {/* Chave do registro: protegida contra edição acidental */}
                <TextInput
                  source="id"
                  label="ID"
                  fullWidth
                  helperText={false}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextInput
                  source="name"
                  label="Eleição"
                  fullWidth
                  helperText={false}
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <NumberInput
                  source="year"
                  label="Ano"
                  fullWidth
                  helperText={false}
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12}>
                {/* Consulta só a partir de 2 caracteres (padrão das
                    demais buscas de sócio do painel) */}
                <ReferenceInput
                  source="userId"
                  reference="users/crud"
                  enableGetChoices={({ mailName }) =>
                    Boolean(mailName && String(mailName).trim().length >= 2)
                  }
                >
                  <AutocompleteInput
                    label="Sócio (nome/e-mail/CPF)"
                    optionText={(choice: any) =>
                      String(
                        choice?.fullName || choice?.email || choice?.id || ""
                      )
                    }
                    optionValue="id"
                    fullWidth
                    helperText={false}
                    noOptionsText="Digite nome, e-mail ou CPF para buscar"
                    filterToQuery={(searchText: string) => ({
                      mailName: searchText,
                    })}
                    validate={required()}
                  />
                </ReferenceInput>
              </Grid>
              <Grid item xs={12}>
                <BooleanInput
                  source="participated"
                  label="Participou da eleição"
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
